var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QMC;
(function (QMC) {
    var Klient;
    (function (Klient) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Klient.HttpProvider = HttpProvider;
    })(Klient = QMC.Klient || (QMC.Klient = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Klient')
        .config(['$httpProvider', QMC.Klient.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Klient;
    (function (Klient) {
        var KlientService = /** @class */ (function (_super) {
            __extends(KlientService, _super);
            function KlientService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Client';
                return _this;
            }
            KlientService.prototype.getClientList = function (page, pagesize, searchString) {
                if (searchString === void 0) { searchString = null; }
                if (searchString !== null && searchString.trim().length === 0) {
                    searchString = null;
                }
                return _super.prototype.getPagination.call(this, this.modulePath, { searchString: searchString, page: page, pageSize: pagesize }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getClientListByPredefinedSearch = function (id, page, pagesize, searchString, onlyActive, searchProperties) {
                if (onlyActive === void 0) { onlyActive = false; }
                if (searchProperties === void 0) { searchProperties = []; }
                if (searchString !== null && searchString.trim().length === 0) {
                    searchString = null;
                }
                return _super.prototype.getPagination.call(this, this.modulePath + '/ByPredefinedSearch/' + id, { searchString: searchString, page: page, pagesize: pagesize, onlyActive: onlyActive, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getClient = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getClientExtendedMainData = function (id) {
                return _super.prototype.getItem.call(this, '/Client/ExtendedMainData/' + id, {}, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getPredefinedSearches = function () {
                return _super.prototype.get.call(this, '/PredefinedSearch', { objecttype: 140000 }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getMinimalClientList = function () {
                return _super.prototype.get.call(this, this.modulePath + '/MinimalList', {}, function (data) {
                    return data.map(function (x) { return (__assign(__assign({}, x), { objectId: x.id })); });
                });
            };
            KlientService.prototype.getClientPersonList = function (searchString, onlyActive) {
                if (searchString === void 0) { searchString = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                return _super.prototype.get.call(this, '/Person/Client', { searchString: searchString, onlyActive: onlyActive }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getEmployeeList = function (searchString, searchId) {
                if (searchString === void 0) { searchString = ""; }
                if (searchId === void 0) { searchId = QMC.Common.Constants.SHOW_ONLY_ACTIVE_EMPLOYEES_PREDEFINED_SEARCH_ID; }
                return _super.prototype.get.call(this, '/Person/Employee', { searchString: searchString, searchId: searchId }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getAllPersonLists = function (listSearch) {
                if (listSearch === void 0) { listSearch = ""; }
                return _super.prototype.get.call(this, '/PersonList', { listSearch: listSearch }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getClientAndEmployeeList = function (searchString, onlyActive) {
                if (searchString === void 0) { searchString = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                return _super.prototype.get.call(this, '/Person/ClientAndEmployee', { searchString: searchString, onlyActive: onlyActive }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getPersonListForLegal = function (searchText, onlyActive, isForWv) {
                if (searchText === void 0) { searchText = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                if (isForWv === void 0) { isForWv = false; }
                return _super.prototype.get.call(this, '/Person/Legal', { searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getPersonListByObjectType = function (objectType, searchText, onlyActive, isForWv) {
                if (searchText === void 0) { searchText = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                if (isForWv === void 0) { isForWv = false; }
                return _super.prototype.get.call(this, '/Person/ByObjectType', { objectType: objectType, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getPersonListByObjectTypes = function (objectTypes, searchText, onlyActive, isForWv) {
                if (searchText === void 0) { searchText = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                if (isForWv === void 0) { isForWv = false; }
                return _super.prototype.get.call(this, '/Person/ByObjectTypes', { objectTypes: objectTypes, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getPersonsByKeyAssignment = function (key, addEmptyItem) {
                if (addEmptyItem === void 0) { addEmptyItem = false; }
                return _super.prototype.getItem.call(this, "/Person/PeopleSelectionAssignment/" + key, { addEmptyItem: addEmptyItem }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getContactPersonListOfPerson = function (parentObjectId, searchText, onlyActive, isForWv, addEmptyItem) {
                if (searchText === void 0) { searchText = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                if (isForWv === void 0) { isForWv = false; }
                if (addEmptyItem === void 0) { addEmptyItem = false; }
                return _super.prototype.get.call(this, '/Person/ContactPersonOfPerson', { parentObjectId: parentObjectId, searchText: searchText, onlyActive: onlyActive, isForWv: isForWv, addEmptyItem: addEmptyItem }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getLegalGuardianList = function (searchText, onlyActive, isForWv) {
                if (searchText === void 0) { searchText = ""; }
                if (onlyActive === void 0) { onlyActive = true; }
                if (isForWv === void 0) { isForWv = false; }
                return _super.prototype.get.call(this, '/Person/LegalGuardianList', { searchText: searchText, onlyActive: onlyActive, isForWv: isForWv }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getAllAddresses = function () {
                return _super.prototype.get.call(this, '/Stammdaten/Address', {}, function (data) {
                    return data;
                });
            };
            KlientService.prototype.putClient = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            KlientService.prototype.putClientExtendedMainData = function (id, data) {
                return _super.prototype.put.call(this, '/Client/ExtendedMainData/' + id, data).then(function (data) {
                    return data;
                });
            };
            KlientService.prototype.getClientWv = function () {
                return _super.prototype.getItem.call(this, '/Client/WvModel', {}, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getUserList = function (addEmptyItem) {
                if (addEmptyItem === void 0) { addEmptyItem = false; }
                return _super.prototype.get.call(this, '/Person/User', { addEmptyItem: addEmptyItem }, function (data) {
                    return data;
                });
            };
            /***** Fls Group *****/
            KlientService.prototype.getFlsGroupList = function (page, pageSize) {
                return _super.prototype.get.call(this, '/Fachleistung/Group', { page: page, pageSize: pageSize }, function (data) {
                    return data;
                });
            };
            KlientService.prototype.getFlsGroupDetail = function (id) {
                return _super.prototype.getItem.call(this, '/Fachleistung/Group/' + id, {}, function (data) {
                    return data;
                });
            };
            /***** misc *****/
            KlientService.prototype.getUpcomingBithdays = function (dateFrom, dateTo, daysToPast, daysToFuture, organization, subOrganization) {
                return _super.prototype.get.call(this, '/Person/Birthdays', { dateFrom: dateFrom, dateTo: dateTo, daysToPast: daysToPast, daysToFuture: daysToFuture, organization: organization, subOrganization: subOrganization }, function (data) {
                    return data;
                });
            };
            KlientService = __decorate([
                QMC.Inject('$http', '$q'),
                QMC.Service('QMC.Klient', 'KlientService')
            ], KlientService);
            return KlientService;
        }(QMC.Common.BaseService));
        Klient.KlientService = KlientService;
    })(Klient = QMC.Klient || (QMC.Klient = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Klient/qmc.klient.js.map
